export const environment = {
  firebaseApiKey: 'AIzaSyBCHzKdgdNz-CkQzn8E6qWZGQbTPhCqL8A'
};